import type React from "react";

import type { UserDto } from "@/api/types";
import { List } from "@/components/List/List";
import { Modal, type ModalBaseProps } from "@/components/Modal/Modal";
import { User } from "@/components/User/User";

type Props = ModalBaseProps & {
  title: string;
  users: UserDto[];
};

export function AddressOverviewUserListModal({ isOpened, onOpenChange, title, users }: Props): React.ReactNode {
  return (
    <Modal.Root
      title={title}
      isOpened={isOpened}
      onOpenChange={onOpenChange}
      size="sm"
      height={680}
      shouldCloseOnEsc
      shouldCloseOnClickOutside
    >
      <Modal.Body>
        <List items={users} getKey={(user) => user.id}>
          {(user) => <User user={user} />}
        </List>
      </Modal.Body>
    </Modal.Root>
  );
}
